import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core';
import { BadgeVariants } from '~backoffice/app/~shared/components/ui/badge/badge.component';
import { InvoiceStatus, InvoiceType } from '~core/models/invoice.models';

@Component({
  selector: 'invoice-status-tag',
  standalone: false,
  templateUrl: './invoice-status-tag.component.html',
  styleUrl: './invoice-status-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceStatusTagComponent {
  statusValue = input.required<InvoiceStatus>();
  invoiceType = input.required<InvoiceType | undefined>();

  statusColor = computed<BadgeVariants['variant']>(() => {
    switch (this.statusValue()) {
      case InvoiceStatus.draft:
        return 'neutral';
      case InvoiceStatus.processing:
        return 'info';
      case InvoiceStatus.validated:
        return 'info';
      case InvoiceStatus.certified:
        return 'success';
      case InvoiceStatus.received:
        return 'primary';
      case InvoiceStatus.cancelled:
        return 'destructive';
      default:
        return 'neutral';
    }
  });
}
